// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 21H1V3H23V21ZM7 8C5.89543 8 5 8.89543 5 10V14C5 15.1046 5.89543 16 7 16H11V14H7V10H11V8H7ZM13 8V16H15V10H17V16H19V9.42871C19 8.6058 18.3188 8.00006 17.5557 8H13Z"}}]};

const ChineseRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chinese-rectangle-filled',
    ref,
    icon: element,
  },
));

ChineseRectangleFilledIcon.displayName = 'ChineseRectangleFilledIcon';

export default ChineseRectangleFilledIcon;
